import { PRICE_MISMATCH_TASK, resolveLegacyTaskType } from 'core/slices/utils/constants';

import Adjustment from './Adjustment';
import Default from './Default';
import MissingLandmark from './MissingLandmark';
import NoLocation from './NoLocation';
import PriceMismatch from './PriceMismatch';
import Promotion from './Promotion';
import Stockout from './Stockout';

/**
 * Returns the appropriate description card component for a given task type.
 * Selects the component based on task_type without rendering it.
 * Allows flexible composition and prevents naming ambiguity with PascalCase.
 */
export default function getDescriptionCard(taskType) {
  switch (resolveLegacyTaskType(taskType)) {
    case 'adjustment':
      return Adjustment;
    case 'inactive_promotion':
    case 'missing_promotion':
      return Promotion;
    case 'missing_in_store':
    case 'unimplemented':
    case 'zero_stock':
      return NoLocation;
    case 'missing_landmark':
      return MissingLandmark;
    case PRICE_MISMATCH_TASK:
      return PriceMismatch;
    case 'stockout':
      return Stockout;
    default:
      return Default;
  }
}
